import Vue from 'vue'
import axios from 'axios'
import VueWait from 'vue-wait'
import VueMask from 'v-mask'

import router from '@builder-web/Routes'
import store from '@builder-web/Store'
import { setStorage } from '@builder-web/Utilities'

import VueIziToast from 'vue-izitoast'
import VueGtag from 'vue-gtag'
import rate from 'vue-rate'
import App from '@builder-web/App.vue'
import ModalProvider from '@shared/Plugins/Modal'
import UserbackPlugin from '@userback/vue2'
import InfiniteLoading from 'vue-infinite-loading'

import '@builder-web/Bootstrap'
import '@builder-web/Theme/app.scss'

import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'

axios.defaults.baseURL = process.env.VUE_APP_API_HOST
    ? process.env.VUE_APP_API_HOST.replace(/"/g, '')
    : 'http://localhost:8000'

Vue.config.productionTip = false

Vue.use(VueMask)
Vue.use(ModalProvider)
Vue.use(VueIziToast)
Vue.use(rate)
Vue.use(VueWait)
Vue.use(InfiniteLoading, {})
Vue.use(
    VueGtag,
    {
        config: { id: 'G-CHFJH6NWY4' },
        appName: 'BidCrete Builder',
        pageTrackerScreenviewEnabled: true,
    },
    router,
)
if (process.env.NODE_ENV !== 'production') {
    Vue.use(UserbackPlugin, {
        token: '5185|12794|5k9WIImNYMsVNUEqtnlXWo1hPLm5nZCNJFLXWTMwTqtkuGrOKr',
    })
}

// An impersonation hand-off from the admin portal must replace any builder
// session already stored in this browser. Handling it on the login route never
// runs while a stored token keeps the router away from that route, which left
// the previous builder's session shadowing the newly impersonated one.
const impersonationToken = new URLSearchParams(window.location.search).get('impersonate_token')

if (impersonationToken) {
    setStorage('token', impersonationToken)
    setStorage('impersonate', 1)
    window.location.replace(process.env.VUE_APP_URL)
} else {
    new Vue({
        router,
        store,
        render: (h) => h(App),
        wait: new VueWait({
            useVuex: true,
        }),
    }).$mount('#app')
}
